import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { SparkleEffect } from '../components/SparkleEffect';
import { GlitterHeart } from '../components/GlitterHeart';
import { SplitFlapQuote } from '../components/SplitFlapQuote';
import { ArrowRightIcon, HeartIcon, MessageCircleIcon, PhoneIcon } from 'lucide-react';
export function FreeResourcesPage() {
  return <div className="min-h-screen bg-white pt-24 pb-24" data-id="element-1528">
      {/* Hero */}
      <section className="relative py-20 text-center overflow-hidden bg-gradient-to-b from-blush-50 to-white" data-id="element-1529">
        <SparkleEffect count={80} data-id="element-1530" />
        <div className="max-w-3xl mx-auto px-4 relative z-10" data-id="element-1531">
          <motion.h1 initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} className="font-heading text-5xl md:text-6xl font-bold text-plum-700 mb-6" data-id="element-1532">
            Trippin' Through <span className="text-cta-500" data-id="element-1533">Guidance</span>
          </motion.h1>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.1
        }} className="text-xl text-plum-500 font-medium" data-id="element-1534">
            Tools, support, and a gentle reminder that you don't have to figure
            it all out alone.
          </motion.p>
        </div>
      </section>

      {/* SPARKLY QUOTE MARQUEE */}
      <SplitFlapQuote data-id="element-1535" />

      {/* REDESIGNED CRISIS SECTION */}
      <section className="py-16 bg-gradient-to-br from-lavender-50 via-blush-50 to-pink-50 relative overflow-hidden" data-id="element-1536">
        <SparkleEffect count={40} data-id="element-1537" />

        {/* Decorative blurred circles for soft glow */}
        <div className="absolute top-0 right-0 w-96 h-96 bg-white/40 rounded-full blur-3xl -translate-y-1/2 translate-x-1/3 pointer-events-none" data-id="element-1538" />
        <div className="absolute bottom-0 left-0 w-96 h-96 bg-pink-100/40 rounded-full blur-3xl translate-y-1/2 -translate-x-1/3 pointer-events-none" data-id="element-1539" />

        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-1540">
          <div className="text-center mb-12" data-id="element-1541">
            <GlitterHeart size={40} variant="light" className="mx-auto mb-4" data-id="element-1542" />
            <h2 className="font-heading text-3xl md:text-4xl font-bold text-plum-700 mb-3" data-id="element-1543">
              If You're Not Okay Right Now
            </h2>
            <p className="text-plum-600 text-lg font-medium max-w-2xl mx-auto" data-id="element-1544">
              You're not alone. You don't have to go through this by yourself.
            </p>
          </div>

          {/* IMMEDIATE CRISIS HELP */}
          <div className="mb-12" data-id="element-1545">
            <h3 className="font-heading text-xl font-bold text-plum-700 mb-6 flex items-center gap-2" data-id="element-1546">
              <span className="text-2xl" data-id="element-1547">🚨</span> Immediate Crisis Help
            </h3>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-1548">
              {/* Card 1: Lifeline */}
              <div className="bg-white rounded-3xl p-6 shadow-md border border-blush-100 flex flex-col h-full" data-id="element-1549">
                <div className="flex items-center gap-3 mb-4" data-id="element-1550">
                  <div className="w-10 h-10 rounded-full bg-sky-50 flex items-center justify-center shrink-0" data-id="element-1551">
                    <PhoneIcon className="w-5 h-5 text-sky-500" data-id="element-1552" />
                  </div>
                  <h4 className="font-bold text-plum-800 text-lg" data-id="element-1553">
                    Suicide & Crisis Lifeline
                  </h4>
                </div>
                <div className="mb-4 flex-grow" data-id="element-1554">
                  <p className="text-plum-600 font-medium mb-1" data-id="element-1555">Call or text</p>
                  <p className="text-4xl font-black text-plum-800 mb-3 tracking-tight" data-id="element-1556">
                    988
                  </p>
                  <p className="text-plum-500 text-sm font-medium flex items-center gap-1.5 mb-1" data-id="element-1557">
                    <span className="text-cta-400" data-id="element-1558">Chat:</span> 988lifeline.org
                  </p>
                  <p className="text-plum-500 text-sm font-medium flex items-center gap-1.5" data-id="element-1559">
                    <span data-id="element-1560">🕒</span> Available 24/7, free & confidential
                  </p>
                </div>
                <a href="https://988lifeline.org/" target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center gap-2 w-full py-3 rounded-xl bg-sky-50 text-sky-600 hover:bg-sky-100 font-bold transition-colors mt-auto" data-id="element-1561">
                  Get Help Now <ArrowRightIcon className="w-4 h-4" data-id="element-1562" />
                </a>
              </div>

              {/* Card 2: Text Line */}
              <div className="bg-white rounded-3xl p-6 shadow-md border border-blush-100 flex flex-col h-full" data-id="element-1563">
                <div className="flex items-center gap-3 mb-4" data-id="element-1564">
                  <div className="w-10 h-10 rounded-full bg-cta-50 flex items-center justify-center shrink-0" data-id="element-1565">
                    <MessageCircleIcon className="w-5 h-5 text-cta-500" data-id="element-1566" />
                  </div>
                  <h4 className="font-bold text-plum-800 text-lg" data-id="element-1567">
                    Crisis Text Line
                  </h4>
                </div>
                <div className="mb-4 flex-grow" data-id="element-1568">
                  <p className="text-plum-600 font-medium mb-1" data-id="element-1569">
                    Text <strong className="text-plum-800" data-id="element-1570">HOME</strong> to
                  </p>
                  <p className="text-4xl font-black text-plum-800 mb-3 tracking-tight" data-id="element-1571">
                    741741
                  </p>
                  <p className="text-plum-500 text-sm font-medium mb-1" data-id="element-1572">
                    Connects you with a trained crisis counselor
                  </p>
                  <p className="text-plum-500 text-sm font-medium flex items-center gap-1.5" data-id="element-1573">
                    <span data-id="element-1574">🕒</span> Available 24/7
                  </p>
                </div>
                <a href="https://www.crisistextline.org/" target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center gap-2 w-full py-3 rounded-xl bg-cta-50 text-cta-600 hover:bg-cta-100 font-bold transition-colors mt-auto" data-id="element-1575">
                  Talk to Someone <ArrowRightIcon className="w-4 h-4" data-id="element-1576" />
                </a>
              </div>

              {/* Card 3: Emergency */}
              <div className="bg-white rounded-3xl p-6 shadow-md border border-blush-100 flex flex-col h-full" data-id="element-1577">
                <div className="flex items-center gap-3 mb-4" data-id="element-1578">
                  <div className="w-10 h-10 rounded-full bg-red-50 flex items-center justify-center shrink-0" data-id="element-1579">
                    <span className="text-xl" data-id="element-1580">🚓</span>
                  </div>
                  <h4 className="font-bold text-plum-800 text-lg" data-id="element-1581">Emergency</h4>
                </div>
                <div className="mb-4 flex-grow" data-id="element-1582">
                  <p className="text-plum-600 font-medium mb-1" data-id="element-1583">Call</p>
                  <p className="text-4xl font-black text-red-500 mb-3 tracking-tight" data-id="element-1584">
                    911
                  </p>
                  <p className="text-plum-500 text-sm font-medium" data-id="element-1585">
                    If someone is in immediate danger
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* SPECIALIZED SUPPORT */}
          <div className="mb-8" data-id="element-1586">
            <h3 className="font-heading text-xl font-bold text-plum-700 mb-6 flex items-center gap-2" data-id="element-1587">
              <span className="text-2xl" data-id="element-1588">💖</span> Specialized Support
            </h3>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-1589">
              {/* Trevor Project */}
              <div className="bg-white rounded-3xl p-6 shadow-sm border border-blush-100" data-id="element-1590">
                <div className="flex items-center gap-3 mb-3" data-id="element-1591">
                  <span className="text-2xl" data-id="element-1592">🌈</span>
                  <h4 className="font-bold text-plum-800" data-id="element-1593">LGBTQ+ Support</h4>
                </div>
                <p className="text-plum-500 text-xs font-bold uppercase tracking-wider mb-3" data-id="element-1594">
                  The Trevor Project
                </p>
                <div className="space-y-2 mb-4" data-id="element-1595">
                  <p className="text-plum-700 font-bold text-lg" data-id="element-1596">
                    1-866-488-7386
                  </p>
                  <p className="text-plum-600 text-sm font-medium" data-id="element-1597">
                    Text <strong className="text-plum-800" data-id="element-1598">START</strong> to{' '}
                    <strong className="text-plum-800" data-id="element-1599">678678</strong>
                  </p>
                  <p className="text-plum-500 text-sm font-medium flex items-center gap-1.5" data-id="element-1600">
                    <span data-id="element-1601">🕒</span> 24/7 support for LGBTQ+ youth
                  </p>
                </div>
                <a href="https://www.thetrevorproject.org/" target="_blank" rel="noopener noreferrer" className="inline-flex items-center text-sm gap-1 text-cta-500 hover:text-cta-600 font-bold transition-colors" data-id="element-1602">
                  Get Support <ArrowRightIcon className="w-3 h-3" data-id="element-1603" />
                </a>
              </div>

              {/* SAMHSA */}
              <div className="bg-white rounded-3xl p-6 shadow-sm border border-blush-100" data-id="element-1604">
                <div className="flex items-center gap-3 mb-3" data-id="element-1605">
                  <span className="text-2xl" data-id="element-1606">🧠</span>
                  <h4 className="font-bold text-plum-800" data-id="element-1607">
                    Mental Health & Substance Use
                  </h4>
                </div>
                <p className="text-plum-500 text-xs font-bold uppercase tracking-wider mb-3" data-id="element-1608">
                  SAMHSA National Helpline
                </p>
                <div className="space-y-2" data-id="element-1609">
                  <p className="text-plum-700 font-bold text-lg" data-id="element-1610">
                    1-800-662-4357
                  </p>
                  <p className="text-plum-500 text-sm font-medium flex items-center gap-1.5" data-id="element-1611">
                    <span data-id="element-1612">🕒</span> 24/7, free, confidential
                  </p>
                </div>
              </div>

              {/* Postpartum */}
              <div className="bg-white rounded-3xl p-6 shadow-sm border border-blush-100" data-id="element-1613">
                <div className="flex items-center gap-3 mb-3" data-id="element-1614">
                  <span className="text-2xl" data-id="element-1615">👩‍👧</span>
                  <h4 className="font-bold text-plum-800" data-id="element-1616">
                    Postpartum Support
                  </h4>
                </div>
                <p className="text-plum-500 text-xs font-bold uppercase tracking-wider mb-3" data-id="element-1617">
                  For Moms (EN/ES)
                </p>
                <div className="space-y-2 mb-4" data-id="element-1618">
                  <p className="text-plum-600 text-sm font-medium" data-id="element-1619">
                    Call or text:
                  </p>
                  <p className="text-plum-700 font-bold text-lg" data-id="element-1620">
                    1-800-944-4773
                  </p>
                  <p className="text-plum-500 text-sm font-medium flex items-center gap-1.5" data-id="element-1621">
                    <span data-id="element-1622">🕒</span> Not 24/7, but very responsive
                  </p>
                </div>
                <a href="https://www.postpartum.net/" target="_blank" rel="noopener noreferrer" className="inline-flex items-center text-sm gap-1 text-cta-500 hover:text-cta-600 font-bold transition-colors" data-id="element-1623">
                  Visit Website <ArrowRightIcon className="w-3 h-3" data-id="element-1624" />
                </a>
              </div>

              {/* Domestic Violence */}
              <div className="bg-white rounded-3xl p-6 shadow-sm border border-blush-100" data-id="element-1625">
                <div className="flex items-center gap-3 mb-3" data-id="element-1626">
                  <span className="text-2xl" data-id="element-1627">💔</span>
                  <h4 className="font-bold text-plum-800" data-id="element-1628">Domestic Violence</h4>
                </div>
                <p className="text-plum-500 text-xs font-bold uppercase tracking-wider mb-3" data-id="element-1629">
                  National Hotline
                </p>
                <div className="space-y-2 mb-4" data-id="element-1630">
                  <p className="text-plum-700 font-bold text-lg" data-id="element-1631">
                    1-800-799-7233
                  </p>
                  <p className="text-plum-600 text-sm font-medium" data-id="element-1632">
                    Text <strong className="text-plum-800" data-id="element-1633">START</strong> to{' '}
                    <strong className="text-plum-800" data-id="element-1634">88788</strong>
                  </p>
                  <p className="text-plum-500 text-sm font-medium flex items-center gap-1.5" data-id="element-1635">
                    <span data-id="element-1636">🕒</span> 24/7
                  </p>
                </div>
                <a href="https://www.thehotline.org/" target="_blank" rel="noopener noreferrer" className="inline-flex items-center text-sm gap-1 text-cta-500 hover:text-cta-600 font-bold transition-colors" data-id="element-1637">
                  Get Support <ArrowRightIcon className="w-3 h-3" data-id="element-1638" />
                </a>
              </div>

              {/* Child Abuse */}
              <div className="bg-white rounded-3xl p-6 shadow-sm border border-blush-100" data-id="element-1639">
                <div className="flex items-center gap-3 mb-3" data-id="element-1640">
                  <span className="text-2xl" data-id="element-1641">👶</span>
                  <h4 className="font-bold text-plum-800" data-id="element-1642">
                    Child Abuse Hotline
                  </h4>
                </div>
                <p className="text-plum-500 text-xs font-bold uppercase tracking-wider mb-3" data-id="element-1643">
                  Childhelp
                </p>
                <div className="space-y-2" data-id="element-1644">
                  <p className="text-plum-600 text-sm font-medium" data-id="element-1645">
                    Call or text:
                  </p>
                  <p className="text-plum-700 font-bold text-lg" data-id="element-1646">
                    1-800-422-4453
                  </p>
                  <p className="text-plum-500 text-sm font-medium flex items-center gap-1.5" data-id="element-1647">
                    <span data-id="element-1648">🕒</span> 24/7
                  </p>
                </div>
              </div>
            </div>
          </div>

          <p className="text-center text-plum-500 font-medium italic mt-12" data-id="element-1649">
            Take a breath. You're going to be okay. 💗
          </p>
        </div>
      </section>

      {/* SECOND MARQUEE - extra positivity */}
      <SplitFlapQuote data-id="element-1650" />

      {/* FREE RESOURCES SECTION */}
      <section className="py-16 bg-white relative overflow-hidden" data-id="element-1651">
        <SparkleEffect count={60} data-id="element-1652" />
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-1653">
          <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-1654">
            <h2 className="font-heading text-4xl md:text-5xl font-bold text-plum-700 mb-6" data-id="element-1655">
              Free Resources & Reset
            </h2>
            <p className="text-lg text-plum-600 font-medium leading-relaxed" data-id="element-1656">
              I've been through some really hard things in life—and I know what
              it feels like to feel stuck, overwhelmed, or alone. If that's
              where you are right now, please know this:{' '}
              <strong className="text-plum-800" data-id="element-1657">
                you matter, and you don't have to figure it all out by yourself.
              </strong>
            </p>
          </div>

          {/* Free Coaching Call - thin wide card above the grid */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="mb-10" data-id="element-1658">
            <a href="https://calendly.com/trippinwithmandy/crisis-call" target="_blank" rel="noopener noreferrer" className="flex flex-col sm:flex-row items-center justify-between gap-4 bg-gradient-to-r from-cta-50 to-pink-50 rounded-2xl px-8 py-5 border-2 border-cta-200 shadow-md hover:shadow-lg hover:-translate-y-0.5 transition-all" data-id="element-1659">
              <div className="flex items-center gap-4" data-id="element-1660">
                <span className="text-3xl" data-id="element-1661">💗</span>
                <div data-id="element-1662">
                  <h3 className="font-heading text-lg font-bold text-plum-800" data-id="element-1663">
                    Need Someone to Talk To?
                  </h3>
                  <p className="text-plum-500 font-medium text-sm" data-id="element-1664">
                    Book a free coaching call — no strings, no judgment, just
                    support.
                  </p>
                </div>
              </div>
              <span className="inline-flex items-center gap-2 px-6 py-2.5 rounded-full bg-cta-500 text-white font-bold text-sm hover:bg-cta-600 transition-colors shadow-lg shadow-cta-500/20 shrink-0" data-id="element-1665">
                Book a Free Call
                <ArrowRightIcon className="w-4 h-4" data-id="element-1666" />
              </span>
            </a>
          </motion.div>

          {/* GRID ROW 1 */}
          <div id="free-lists" className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mb-8 scroll-mt-32" data-id="element-1667">
            {/* Interactive Cleaning Schedule Card */}
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} className="bg-gradient-to-br from-cta-50 to-white rounded-3xl p-8 border-2 border-cta-200 shadow-md flex flex-col relative overflow-hidden" data-id="element-1668">
              <div className="absolute top-4 right-4 bg-cta-500 text-white text-xs font-bold px-4 py-2 rounded-full shadow-lg transform rotate-12" data-id="element-1669">
                NEW ✨
              </div>
              <div className="text-3xl mb-4" data-id="element-1670">✨</div>
              <h3 className="font-heading text-2xl font-bold text-plum-800 mb-4" data-id="element-1671">
                Free Interactive Cleaning Schedule
              </h3>
              <p className="text-plum-600 font-medium mb-8 flex-grow" data-id="element-1672">
                The Ultimate Cleaning Schedule — what to clean & when. Check
                things off, track your progress, use it every week for free!
              </p>
              <Link to="/free-resources/cleaning-schedule" className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-full bg-cta-500 text-white font-bold text-sm hover:bg-cta-600 transition-colors shadow-lg shadow-cta-500/20 w-full" data-id="element-1673">
                Try It Now
                <ArrowRightIcon className="w-4 h-4" data-id="element-1674" />
              </Link>
            </motion.div>

            {/* Interactive Self-Care Schedule Card */}
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: 0.1
          }} className="bg-gradient-to-br from-pink-50 to-white rounded-3xl p-8 border-2 border-pink-200 shadow-md flex flex-col relative overflow-hidden" data-id="element-1675">
              <div className="absolute top-4 right-4 bg-pink-500 text-white text-xs font-bold px-4 py-2 rounded-full shadow-lg transform rotate-12" data-id="element-1676">
                NEW 🧖‍♀️
              </div>
              <div className="text-3xl mb-4" data-id="element-1677">🧖‍♀️</div>
              <h3 className="font-heading text-2xl font-bold text-pink-800 mb-4" data-id="element-1678">
                Free Interactive Self-Care Checklist
              </h3>
              <p className="text-pink-600 font-medium mb-8 flex-grow" data-id="element-1679">
                Daily hygiene and wellness ritual. Take care of your body and
                mind with this simple, trackable daily routine!
              </p>
              <Link to="/free-resources/self-care/daily" className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-full bg-pink-500 text-white font-bold text-sm hover:bg-pink-600 transition-colors shadow-lg shadow-pink-500/20 w-full" data-id="element-1680">
                Try It Now
                <ArrowRightIcon className="w-4 h-4" data-id="element-1681" />
              </Link>
            </motion.div>

            {/* Free Pre-Trip Home Prep Card */}
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: 0.15
          }} className="bg-gradient-to-br from-emerald-50 to-teal-50 rounded-3xl p-8 border-2 border-emerald-200 shadow-md flex flex-col relative overflow-hidden" data-id="element-1682">
              <div className="absolute top-4 right-4 bg-emerald-500 text-white text-xs font-bold px-4 py-2 rounded-full shadow-lg transform rotate-12" data-id="element-1683">
                NEW 🏡
              </div>
              <div className="text-3xl mb-4" data-id="element-1684">🏡</div>
              <h3 className="font-heading text-2xl font-bold text-emerald-800 mb-4" data-id="element-1685">
                Free Pre-Trip Home Prep Checklist
              </h3>
              <p className="text-emerald-600 font-medium mb-8 flex-grow" data-id="element-1686">
                What to do before you leave so you come back to a peaceful,
                clean home. 10 sections covering everything from kitchen prep to
                security!
              </p>
              <Link to="/free-resources/travel/home-prep" className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-full bg-emerald-500 text-white font-bold text-sm hover:bg-emerald-600 transition-colors shadow-lg shadow-emerald-500/20 w-full" data-id="element-1687">
                Try It Now
                <ArrowRightIcon className="w-4 h-4" data-id="element-1688" />
              </Link>
            </motion.div>

            {/* FREE WORKOUT CONSULTATION Card */}
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: 0.2
          }} className="bg-gradient-to-br from-sky-50 to-lavender-50 rounded-3xl p-8 border-2 border-sky-200 shadow-md flex flex-col relative overflow-hidden" data-id="element-1689">
              <div className="absolute top-4 right-4 bg-sky-500 text-white text-xs font-bold px-4 py-2 rounded-full shadow-lg transform rotate-12" data-id="element-1690">
                FREE 💪
              </div>
              <div className="text-3xl mb-4" data-id="element-1691">💪</div>
              <h3 className="font-heading text-2xl font-bold text-plum-800 mb-4" data-id="element-1692">
                Free Workout Consultation
              </h3>
              <p className="text-plum-600 font-medium mb-3 flex-grow" data-id="element-1693">
                Meet Jake — once the smallest in the room, now lifting over 500
                lbs and training for championship-level competition. His journey
                is proof of what consistency and discipline can do.
              </p>
              <p className="text-plum-500 text-sm font-medium mb-6" data-id="element-1694">
                Free consultations, zero pressure — just real advice from
                someone who's been exactly where you are.
              </p>
              <a href="https://calendly.com/trippinwithmandy/jakes-free-workout-consultation" target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-full bg-sky-500 text-white font-bold text-sm hover:bg-sky-600 transition-colors shadow-lg shadow-sky-500/20 w-full" data-id="element-1695">
                Book Free Consultation
                <ArrowRightIcon className="w-4 h-4" data-id="element-1696" />
              </a>
            </motion.div>
          </div>

          {/* PANIC ATTACK GROUNDING - Full width between rows */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="bg-gradient-to-br from-blush-50 to-lavender-50 rounded-3xl p-8 md:p-10 shadow-lg border border-blush-100 my-12" data-id="element-1697">
            <div className="text-center mb-6" data-id="element-1698">
              <div className="text-4xl mb-3" data-id="element-1699">🫧</div>
              <h2 className="font-heading text-2xl md:text-3xl font-bold text-plum-700 mb-2" data-id="element-1700">
                Struggling with a Panic Attack?
              </h2>
              <p className="text-plum-500 font-semibold" data-id="element-1701">
                If you're having anxiety or a panic attack, try this grounding
                technique:
              </p>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6 max-w-3xl mx-auto" data-id="element-1702">
              <div className="bg-white/80 rounded-2xl p-6 text-center border border-blush-100 shadow-sm" data-id="element-1703">
                <span className="text-3xl block mb-3" data-id="element-1704">👀</span>
                <h3 className="font-bold text-plum-800 text-lg mb-1" data-id="element-1705">
                  See 5 things
                </h3>
                <p className="text-plum-500 font-medium text-sm" data-id="element-1706">
                  Look around and name 5 things you can see right now.
                </p>
              </div>
              <div className="bg-white/80 rounded-2xl p-6 text-center border border-blush-100 shadow-sm" data-id="element-1707">
                <span className="text-3xl block mb-3" data-id="element-1708">✋</span>
                <h3 className="font-bold text-plum-800 text-lg mb-1" data-id="element-1709">
                  Feel 5 things
                </h3>
                <p className="text-plum-500 font-medium text-sm" data-id="element-1710">
                  Touch 5 different textures — your shirt, the table, your hair.
                </p>
              </div>
              <div className="bg-white/80 rounded-2xl p-6 text-center border border-blush-100 shadow-sm" data-id="element-1711">
                <span className="text-3xl block mb-3" data-id="element-1712">👂</span>
                <h3 className="font-bold text-plum-800 text-lg mb-1" data-id="element-1713">
                  Hear 5 things
                </h3>
                <p className="text-plum-500 font-medium text-sm" data-id="element-1714">
                  Close your eyes and listen for 5 sounds around you.
                </p>
              </div>
            </div>
            <p className="text-cta-500 font-bold text-center mt-6 text-sm italic" data-id="element-1715">
              This helps bring your mind back to the present moment. You're
              going to be okay. 💗
            </p>
          </motion.div>

          {/* GRID ROW 2 */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mb-16" data-id="element-1716">
            {/* Card 1 */}
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: 0.1
          }} className="bg-blush-50 rounded-3xl p-8 border border-blush-100 shadow-sm" data-id="element-1717">
              <div className="text-3xl mb-4" data-id="element-1718">🧘‍♀️</div>
              <h3 className="font-heading text-2xl font-bold text-plum-700 mb-4" data-id="element-1719">
                Things You Can Do Right Now
              </h3>
              <ul className="space-y-3 text-plum-600 font-medium" data-id="element-1720">
                <li className="flex items-start gap-2" data-id="element-1721">
                  <span className="text-cta-500 mt-1" data-id="element-1722">•</span> Take a deep
                  breath (seriously—slow it down)
                </li>
                <li className="flex items-start gap-2" data-id="element-1723">
                  <span className="text-cta-500 mt-1" data-id="element-1724">•</span> Drink some water
                </li>
                <li className="flex items-start gap-2" data-id="element-1725">
                  <span className="text-cta-500 mt-1" data-id="element-1726">•</span> Step outside for
                  a few minutes
                </li>
                <li className="flex items-start gap-2" data-id="element-1727">
                  <span className="text-cta-500 mt-1" data-id="element-1728">•</span> Text someone you
                  trust
                </li>
                <li className="flex items-start gap-2" data-id="element-1729">
                  <span className="text-cta-500 mt-1" data-id="element-1730">•</span> Put on music that
                  grounds you
                </li>
              </ul>
            </motion.div>

            {/* Card 2 */}
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: 0.2
          }} className="bg-lavender-50 rounded-3xl p-8 border border-lavender-100 shadow-sm" data-id="element-1731">
              <div className="text-3xl mb-4" data-id="element-1732">📓</div>
              <h3 className="font-heading text-2xl font-bold text-plum-700 mb-4" data-id="element-1733">
                Quick Reset Questions
              </h3>
              <ul className="space-y-3 text-plum-600 font-medium" data-id="element-1734">
                <li className="flex items-start gap-2" data-id="element-1735">
                  <span className="text-cta-500 mt-1" data-id="element-1736">•</span> What am I feeling
                  right now?
                </li>
                <li className="flex items-start gap-2" data-id="element-1737">
                  <span className="text-cta-500 mt-1" data-id="element-1738">•</span> What do I
                  actually need today?
                </li>
                <li className="flex items-start gap-2" data-id="element-1739">
                  <span className="text-cta-500 mt-1" data-id="element-1740">•</span> What's one small
                  thing I can do?
                </li>
              </ul>
            </motion.div>

            {/* Card 3 */}
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: 0.3
          }} className="bg-sky-50 rounded-3xl p-8 border border-sky-100 shadow-sm" data-id="element-1741">
              <div className="text-3xl mb-4" data-id="element-1742">🎧</div>
              <h3 className="font-heading text-2xl font-bold text-plum-700 mb-4" data-id="element-1743">
                My Go-To Distractions
              </h3>
              <ul className="space-y-3 text-plum-600 font-medium" data-id="element-1744">
                <li className="flex items-start gap-2" data-id="element-1745">
                  <span className="text-cta-500 mt-1" data-id="element-1746">•</span> A comfort show
                  (Gilmore Girls, anyone?)
                </li>
                <li className="flex items-start gap-2" data-id="element-1747">
                  <span className="text-cta-500 mt-1" data-id="element-1748">•</span> A podcast that
                  feels like talking to a friend
                </li>
                <li className="flex items-start gap-2" data-id="element-1749">
                  <span className="text-cta-500 mt-1" data-id="element-1750">•</span> Scrolling through
                  travel TikToks
                </li>
              </ul>
            </motion.div>
          </div>
        </div>
      </section>
    </div>;
}